import { postListFetcher } from '@/shared/api/list';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { deletePress } from './api';

const LIST_KEY = 'publications-press';

interface Press extends ListRow {
  id: number;
  title?: string;
  summary?: string;
  link?: string;
  create_time?: number;
  update_time?: number;
}

const config: ListPageConfig<Press> = {
  queryKey: LIST_KEY,
  title: 'Пресса о нас',
  errorText: 'Ошибка загрузки публикаций прессы',
  fetchList: postListFetcher('/publication/mass-media/list/'),
  rows: ['publications'],
  columns: [
    { header: 'id', render: (press) => press.id },
    { header: 'Заголовок', render: (press) => press.title },
    { header: 'Текст', render: (press) => press.summary },
    { header: 'Ссылка', render: (press) => press.link },
    { header: 'Время создания', render: (press) => formatUnixDateTime(press.create_time) },
    { header: 'Время обновления', render: (press) => formatUnixDateTime(press.update_time) },
    {
      header: 'Удалить',
      render: (press) => <DeleteButton listKey={LIST_KEY} remove={() => deletePress(press.id)} />,
    },
  ],
};

export const PressPage = () => <GenericListPage config={config} />;
